import React from 'react'

import { Fieldset } from '@fourthwall/components'

import type { Post, VideoPostType } from '../../../../../../types'
import { VideoFields } from '../../../../../Post/modules/VideoFields'

type Props = {
  type: VideoPostType
  typeFieldName: string
  video?: string | File
  videoFieldName: string
  thumbnail?: string | File
  thumbnailFieldName: string
  url?: string
  urlFieldName: string
  uploadProgress?: number
  isThumbnailCustom?: boolean
  isUploading?: boolean
  status?: Post['statuses']['resources']
}

export const VideoFieldsComponent = ({
  type,
  typeFieldName,
  video,
  videoFieldName,
  thumbnail,
  thumbnailFieldName,
  url,
  urlFieldName,
  uploadProgress,
  isThumbnailCustom,
  isUploading,
  status,
}: Props) => {
  return (
    <Fieldset.Row>
      <Fieldset.Item>
        <VideoFields
          type={type}
          typeFieldName={typeFieldName}
          video={video}
          videoFieldName={videoFieldName}
          thumbnail={thumbnail}
          thumbnailFieldName={thumbnailFieldName}
          url={url}
          urlFieldName={urlFieldName}
          uploadProgress={uploadProgress}
          isThumbnailCustom={isThumbnailCustom}
          isUploading={isUploading}
          status={status}
        />
      </Fieldset.Item>
    </Fieldset.Row>
  )
}
